import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import classNames from 'classnames';

import { Button, Modal, ModalFooter, ModalBody } from '@spotahome/ui-library';

import './AlertModalContainer.scss';

const getButtonKeys = isDelete =>
  isDelete
    ? {
        acceptKey: 'alerts.modal.button.accept.delete',
        cancelKey: 'alerts.modal.button.cancel.delete'
      }
    : {
        acceptKey: 'alerts.modal.button.accept'
      };

class AlertModalContainer extends PureComponent {
  static propTypes = {
    handleCancel: PropTypes.func.isRequired,
    handleAccept: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    hasError: PropTypes.bool,
    isOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    isDelete: PropTypes.bool,
    hasCancelButton: PropTypes.bool
  };

  static defaultProps = {
    hasError: false,
    isOpen: false,
    isLoading: false,
    isDelete: false,
    hasCancelButton: false
  };

  handleCloseModal = () => {
    if (!this.props.isLoading) {
      this.props.handleCancel();
    }
  };

  render() {
    const { acceptKey, cancelKey } = getButtonKeys(this.props.isDelete);
    const { isDelete, hasCancelButton } = this.props;

    const modalButtonClassName = classNames('alert-modal__footer-button', {
      'alert-modal--footer-button-alert': hasCancelButton
    });

    const modalButtonWrapperClassName = classNames(
      'alert-modal__button-wrapper',
      {
        'alert-modal__button-wrapper--with-cancel': hasCancelButton,
        'alert-modal__button-wrapper--without-cancel': !hasCancelButton
      }
    );

    return (
      <Modal
        isOpen={this.props.isOpen}
        contentLabel="modal"
        onRequestClose={this.handleCloseModal}
        className="alert-modal"
        size="big"
      >
        <ModalBody className="alert-modal__body">
          {this.props.children}
        </ModalBody>
        <ModalFooter className="alert-modal__footer">
          <div className={modalButtonWrapperClassName}>
            {hasCancelButton && (
              <Button
                disabled={this.props.isLoading}
                size="big"
                alt
                onClick={this.props.handleCancel}
                className={modalButtonClassName}
                data-cy="ModalButtonCancel"
              >
                {trans(cancelKey)}
              </Button>
            )}
            <Button
              disabled={this.props.hasError || this.props.isLoading}
              size="big"
              onClick={this.props.handleAccept}
              className={modalButtonClassName}
              data-cy="ModalButtonAccept"
            >
              {trans(acceptKey)}
            </Button>
          </div>
          {!isDelete && (
            <p className="alert-modal__disclaimer">
              {trans('alerts.modal.footer_message')}
            </p>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default AlertModalContainer;
